import { render, staticRenderFns } from "./NewsMessageList.vue?vue&type=template&id=24aad4ba&"
import script from "./NewsMessageList.vue?vue&type=script&lang=js&"
export * from "./NewsMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports